import { Button } from '@upme/ui/components/button';
import { Collapsible, CollapsibleContent, CollapsibleTrigger } from '@upme/ui/components/collapsible';

/** Инструкция «как подключить чат». Имя бота — VITE_TELEGRAM_BOT_USERNAME (без @). */
export function BroadcastSetupHint({ defaultOpen }: { defaultOpen: boolean }) {
  const bot = import.meta.env.VITE_TELEGRAM_BOT_USERNAME;
  const botRef = bot ? `бота @${bot}` : 'бота';
  const chatIdCommand = bot ? `/chatid@${bot}` : '/chatid';

  return (
    <Collapsible defaultOpen={defaultOpen} className="rounded-md border p-3">
      <CollapsibleTrigger asChild>
        <Button variant="link" className="h-auto p-0">
          Как подключить чат
        </Button>
      </CollapsibleTrigger>
      <CollapsibleContent>
        <ol className="mt-2 list-decimal space-y-1 pl-5 text-sm">
          <li>Добавьте {botRef} в городской чат.</li>
          <li>
            Назначьте бота администратором с правом удалять сообщения (для канала — ещё публиковать
            сообщения).
          </li>
          <li>
            Публичный чат — вставьте <code>@username</code> или ссылку <code>t.me/…</code>. Приватная группа —
            отправьте в ней <code>{chatIdCommand}</code> и вставьте присланный id. Приватный канал — после
            назначения бота админом он пришлёт id вам в личку (если вы запускали бота); либо вставьте ссылку
            на любой пост канала <code>t.me/c/…</code>.
          </li>
          <li>Нажмите «Привязать» — бот проверит права.</li>
        </ol>
      </CollapsibleContent>
    </Collapsible>
  );
}
